import * as d3Select from 'd3-selection';

class WaterWave {
    constructor(opt) {
        this.globalConfig = Object.assign({
            //数据
            data: [],

            //指定绑定的div的id，svg会注入这个容器
            bindingDivId:'container',

            //球的半径
            ballDiameter: 65,

            // 球边框的配置
            ballBorder: {
                color: '#333438',
                width: 2
            },
            // {number} 波浪移动的频率
            waveInterval: 1.5, 

            // 球文字的配置
            ballLabel: {
                color: '#fff',
                fontSize: 12
            },

            //字体大小和颜色
            itemLabel: {
                fontSize:12,
                color:'#fff'
            },
            // 虚线线宽,颜色
            line:{
                width:1,
                color:'#006DB9'
            },

            //svg的背景颜色
            background: '#202126',
       
            //画布离svg上边缘的距离
            topPadding:80,

            //图片上下两边的贝塞尔曲线的弯曲程度，越大则越向外拐
            bezierAngle:20,

            //因为左边的球位置关系不一样，所以做了特殊处理。这边指定这个球是哪个球。
            //设计中最左边的那个球，所有边最终指向的那个点
            originName:'宏观数据',

            animateRunTime: undefined // {number} 如果设置，需要是waveInterval的整数倍，否则停止时画面有跳跃
        }, opt);

        this.anchorStore = {
            left: [], //左边的锚点  direction
            right: [], //右边的锚点
            top: [], //顶部的锚点
            bottom: [], //底部的锚点
            originTop: [], //最左边的球右边偏上的锚点,特殊处理
            originBottom: [] //最左边的球右边偏下的锚点,特殊处理
        };

        this.nodeLayout = {
            node: [
                {
                    name: '宏观数据',
                    x: 10,
                    y: 75
                },
                {
                    name: '市场估值',
                    x: 250,
                    y: 0
                },
                {
                    name: '指数估值',
                    x: 500,
                    y: 0
                },
                {
                    name: '两市总市值',
                    x: 750,
                    y: 0
                },
                {
                    name: '两市成交额',
                    x: 1000,
                    y: 0
                },
                {
                    name: '货币流动性',
                    x: 250,
                    y: 180
                },
                {
                    name: 'M1',
                    x: 500,
                    y: 180
                },

                {
                    name: 'DR007',
                    x: 750,
                    y: 180
                }
            ],
            lines: [
                {
                    from: {name: '市场估值', direction: 'left'},
                    to: {name: '宏观数据', direction: 'originTop'},
                    type: 'up'
                },
                {
                    from: {name: '货币流动性', direction: 'left'},
                    to: {name: '宏观数据', direction: 'originBottom'},
                    type: 'down'
                },
                {
                    from: {name: '指数估值', direction: 'top'},
                    to: {name: '市场估值', direction: 'top'},
                    type: 'up'
                },
                {
                    from: {name: '两市总市值', direction: 'top'},
                    to: {name: '市场估值', direction: 'top'},
                    type: 'up'
                },
                {
                    from: {name: '两市成交额', direction: 'top'},
                    to: {name: '市场估值', direction: 'top'},
                    type: 'up'
                },
                {
                    from: {name: 'M1', direction: 'bottom'},
                    to: {name: '货币流动性', direction: 'bottom'},
                    type: 'down'
                },
                {
                    from: {name: 'DR007', direction: 'bottom'},
                    to: {name: '货币流动性', direction: 'bottom'},
                    type: 'down'
                }
            ]
        };

        this.patternList = [];
        this.circleList = [];
        this.rectList = [];
        this.width = this.getWidth();
        this.height = this.getHeight();
    }

    getWidth(){
        return document.getElementById(this.globalConfig.bindingDivId).offsetWidth
    }

    getHeight(){
        return document.getElementById(this.globalConfig.bindingDivId).offsetHeight
    }

    transferX(oriPosX) {
        return oriPosX / 1250 * this.width;
    }

    transferY(oriPosY) {
        return oriPosY / 500 * this.height;
    }

    draw() {
        this.svg = d3Select
            .select(`#${this.globalConfig.bindingDivId}`)
            .append('svg'); //在绑定div中注入this.svg

        this.svg
            .attr('width', this.width)
            .attr('height', this.height)
            .attr('style', `background:${this.globalConfig.background}`);

        let defs = this.svg.append('defs'); //创建defs，一些固定的图形样式将添加在里面，然后用use元素引用即可
        this.defs=defs;
        //添加当前的mask  箭头
        defs.html(`
            <marker id="marker-arrow" viewBox="0 0 20 20"
                refX="10" refY="5" 
                markerUnits="strokeWidth"
                markerWidth="10" markerHeight="10"
                orient="auto">
            <path d="M 0 0 L 10 5 L 0 10 z" fill="${
                this.globalConfig.line.color
            }" />
            </marker> `);

        //添加遮盖版 
        let rect = defs
            .append('rect')
            .attr('id', 'wave')
            .attr('mask', 'url(#circleMask)')
            .attr('x', '0')
            .attr('y', '0')
            .attr('width', '1000')
            .attr('height', this.globalConfig.ballDiameter);

        let mask = defs.append('mask').attr('id', 'circleMask');
        mask.append('circle')
            .attr('r', this.globalConfig.ballDiameter / 2)
            .attr('cx', this.globalConfig.ballDiameter / 2)
            .attr('cy', this.globalConfig.ballDiameter / 2)
            .attr('fill', 'white');

        //添加轮廓
        let circle = defs
            .append('circle')
            .attr('id', 'circle')
            .attr('r', this.globalConfig.ballDiameter / 2)
            .attr('cx', this.globalConfig.ballDiameter / 2)
            .attr('cy', this.globalConfig.ballDiameter / 2);

        //以上部分为初始化部分，来源于初始版本，具体原理请参照./src/firstVersion.md
        //将nodeLayout中各个点绘制
        this.nodeLayout.node.forEach((item, index) => {
            let itemCopy = Object.assign({}, item);
            itemCopy.y += this.globalConfig.topPadding;
            itemCopy.y = this.transferY(itemCopy.y);
            itemCopy.x = this.transferX(itemCopy.x);
            itemCopy.index = index;
            this.addWaterBall(itemCopy);
        });

        //绘制各个边
        this.nodeLayout.lines.forEach(item => {
            let from = item.from;
            let to = item.to;
            let fromPos = this.anchorStore[from.direction].filter(
                item => item.name == from.name
            )[0];
            let toPos = this.anchorStore[to.direction].filter(
                item => item.name == to.name
            )[0];
            this.drawBezierLine(fromPos, toPos, item);
        });
    }

    //将data中的数据加载到绘图中
    addWaterBall(config) {
        let downloadData = this.globalConfig.data.nodeData.filter(
            item => item.name === config.name
        )[0];
        //将数据中的百分比倒转（因为画的是rect波浪的高度，也就是‘空白的部分'
        config.percentile = 1 - downloadData.percentile;
        config.color = downloadData.color;

        let svg = this.svg;
        let defs = svg.select('defs');
        let globalConfig = this.globalConfig;
        let anchorStore = this.anchorStore;
        let patternPathWidth = 125;

        //添加这个球专属的pattern,将name设为id便与索引
        let pattern = defs
            .append('pattern')
            .attr('id', config.name)
            .attr('width', patternPathWidth)
            .attr('height', globalConfig.ballDiameter)
            .attr('patternUnits', 'userSpaceOnUse');

        //在pattern中添加path，详见firstVersion.md
        // 水波形状
        pattern
            .append('path')
            .attr('fill', globalConfig.background)
            // .attr('stroke','red')
            // .attr('stroke-width','1') @TODO:增加波浪的边框
            .attr(
                'd',
                `M 0,${globalConfig.ballDiameter *
                    config.percentile}  C${patternPathWidth/2},${globalConfig.ballDiameter *
                    config.percentile -
                    20} ${patternPathWidth/2},${globalConfig.ballDiameter * config.percentile +
                    20} ${patternPathWidth},${globalConfig.ballDiameter *
                    config.percentile} L ${patternPathWidth},0 L 0,0 Z`
            );

        if (globalConfig.animateRunTime) {
            pattern
                .append('animateTransform')
                .attr('attributeType', 'xml')
                .attr('attributeName', 'patternTransform')
                .attr('type', 'translate')
                .attr('from', '0')
                .attr('to', patternPathWidth)
                .attr('dur', globalConfig.waveInterval+'s')
                .attr('repeatDur', globalConfig.animateRunTime);
        }else{
            pattern
                .append('animateTransform')
                .attr('attributeType', 'xml')
                .attr('attributeName', 'patternTransform')
                .attr('type', 'translate')
                .attr('from', '0')
                .attr('to', patternPathWidth)
                .attr('dur', globalConfig.waveInterval+'s')
                .attr('repeatCount', 'indefinite');
        }

        // 添加渐变颜色 遮罩渐变
        let color = defs
            .append('linearGradient')
            .attr('x1', '0%')
            .attr('y1', '0%')
            .attr('y2', '100%')
            .attr('id', config.name + 'color')
            .attr('x2', '0%');

        color
            .append('stop')
            .attr('offset', '0%')
            .attr('style', `stop-color:${config.color};stop-opacity:1`);
        color
            .append('stop')
            .attr('offset', '100%')
            .attr(
                'style',
                `stop-color:${this.globalConfig.background};stop-opacity:1`
            );
        let g = svg.append('g');

        //在对应的坐标中利用use添加圆形

        let circle = g
            .append('use')
            .attr('x', config.x)
            .attr('y', config.y)
            .attr('xlink:href', '#circle')
            .attr('stroke', this.globalConfig.ballBorder.color)
            .attr('stroke-width', this.globalConfig.ballBorder.width)
            .attr('fill', `url(#${config.name}color)`);
        //在对应的坐标中利用use添加rect
        let rect = g
            .append('use')
            .attr('x', config.x)
            .attr('y', config.y)
            .attr('xlink:href', '#wave')
            .attr('fill', `url(#${config.name})`);
        //添加底部标题文字
        let text = g
            .append('text')
            .text(config.name)
            .attr('text-anchor', 'middle')
            .attr('x', config.x + globalConfig.ballDiameter / 2)
            .attr('y', config.y + globalConfig.ballDiameter + 20)
            .attr('font-size', this.globalConfig.itemLabel.fontSize)
            .attr('fill', this.globalConfig.itemLabel.color);

        //生成一个映射函数，可以把百分比映射为离散的文字。0-0.4自动辨认为‘偏低’，0.4-0.7被认为适中，0.7-1.0为偏高,以此类推。

        let remarkTrans = function(d) {
            if (d < 0) return '错误';
            else if (d < 0.3) return '偏低';
            else if (d < 0.7) return '适中';
            else if (d < 1) return '偏高';
            else return '爆表';
        };

        //添加remark
        let remark = g
            .append('text')
            .text(remarkTrans(1 - config.percentile))
            .attr('text-anchor', 'middle')
            .attr('x', config.x + globalConfig.ballDiameter / 2)
            .attr('y', config.y + (globalConfig.ballDiameter * 4) / 5)
            .attr('fill', this.globalConfig.ballLabel.color)
            .attr('font-size', this.globalConfig.ballLabel.fontSize)
            // .attr('font-weight', 'bold');

        let clickboard = g
            .append('use')
            .attr('x', config.x)
            .attr('y', config.y)
            .attr('xlink:href', '#circle')
            .attr('class', 'ww-clickable')
            .attr('data-nodeid', config.index)
            .attr('fill', 'transparent');
        //添加锚点，如果为最左边的圆的话增加特殊处理，留下特殊的锚点originTop和originBottom
        if (config.name === globalConfig.originName) {
            let offsetDeg = 20;
            anchorStore.originTop.push({
                name: config.name,
                x:
                    config.x +
                    globalConfig.ballDiameter / 2 +
                    (globalConfig.ballDiameter / 2) *
                        Math.cos((offsetDeg / 180) * Math.PI),
                y:
                    config.y +
                    globalConfig.ballDiameter / 2 -
                    (globalConfig.ballDiameter / 2) *
                        Math.sin((offsetDeg / 180) * Math.PI)
            });
            anchorStore.originBottom.push({
                name: config.name,
                x:
                    config.x +
                    globalConfig.ballDiameter / 2 +
                    (globalConfig.ballDiameter / 2) *
                        Math.cos((offsetDeg / 180) * Math.PI),
                y:
                    config.y +
                    globalConfig.ballDiameter / 2 +
                    (globalConfig.ballDiameter / 2) *
                        Math.sin((offsetDeg / 180) * Math.PI)
            });
        }
        //添加每个位置对应的锚点，方便后面画贝塞尔曲线的时候进行引用。
        anchorStore.top.push({
            name: config.name,
            x: config.x + globalConfig.ballDiameter / 2,
            y: config.y
        });
        anchorStore.left.push({
            name: config.name,
            x: config.x,
            y: config.y + globalConfig.ballDiameter / 2
        });
        anchorStore.bottom.push({
            name: config.name,
            x: config.x + globalConfig.ballDiameter / 2,
            y: config.y + globalConfig.ballDiameter + 30
        });
        anchorStore.right.push({
            name: config.name,
            x: config.x + globalConfig.ballDiameter,
            y: config.y + globalConfig.ballDiameter / 2
        });
    }

    getNodeByName(name){
        return this.globalConfig.data.nodeData.filter((i)=>{
            return i.name === name
        })[0];
    }

    // 画流动的虚线
    drawBezierLine(fromObj, toObj, config) {
        let svg = this.svg;
        let qx, qy, div; //因为采取一阶贝塞尔曲线来做曲线，qx,qy为贝塞尔曲线的调节点。
        //对等高的点之间做特殊处理
        if (toObj.y === fromObj.y) {
            //见readME原理解释1
            let offset =
                (Math.abs(toObj.x - fromObj.x) / 2) *
                Math.tan((this.globalConfig.bezierAngle / 180) * Math.PI);
            qx = (toObj.x + fromObj.x) / 2;
            config.type === 'down'
                ? (qy = toObj.y + offset)
                : (qy = toObj.y - offset);
        } else {
        //对于非等高的点判断toObj在fromObj的那个象限内，然后根据需要的是凹的曲线还是凸的曲线来决定调节点的位置。
            if (toObj.x - fromObj.x >= 0) {
                if (toObj.y - fromObj.y >= 0) div = 0;
                else div = 3;
            } else {
                if (toObj.y - fromObj.y >= 0) div = 1;
                else div = 2;
            }
            if (config.type === 'down') {
                switch (div) {
                    case 0: {
                        qy = toObj.y;
                        break;
                    }
                    case 1: {
                        qy = toObj.y;
                        break;
                    }
                    case 2: {
                        qy = fromObj.y;
                        break;
                    }
                    case 3: {
                        qy = fromObj.y;
                        break;
                    }
                }
            } else {
                switch (div) {
                    case 0: {
                        qy = fromObj.y;
                        break;
                    }
                    case 1: {
                        qy = fromObj.y;
                        break;
                    }
                    case 2: {
                        qy = toObj.y;
                        break;
                    }
                    case 3: {
                        qy = toObj.y;
                        break;
                    }
                }
            }
            qx = (fromObj.x + toObj.x) / 2; //qx需要设定为fromObj到toObj的终点，不然箭头指向会垂直。
        }
        var fromObjInfo = this.getNodeByName(fromObj.name);
        //添加曲线
        let g=this.defs.append('g').html(`<marker id="${fromObj.name}arrow" viewBox="0 0 20 20"
                refX="10" refY="5" 
                markerUnits="strokeWidth"
                markerWidth="20" markerHeight="20"
                orient="auto">  </marker>`)
        let marker=g.select(`marker`)
        marker.html(`  <path d="M 0 0 L 10 5 L 0 10 z" fill="${
                fromObjInfo&&fromObjInfo.lineColor? fromObjInfo.lineColor : this.globalConfig.line.color
            }" />`)

        let line = svg
            .append('path')
            .attr('d', `M ${fromObj.x},${fromObj.y} Q ${qx},${qy} ${toObj.x},${toObj.y}`)
            .attr('stroke-width', this.globalConfig.line.width)
            .attr('stroke-dasharray', '4,2')
            .attr('stroke', fromObjInfo&&fromObjInfo.lineColor? fromObjInfo.lineColor : this.globalConfig.line.color)
            .attr('fill', 'none')
            .attr('marker-end', `url(#${fromObj.name}arrow)`);

        //给曲线添加动画效果
        if (this.globalConfig.animateRunTime) {
            line.append('animate')
                .attr('attributeName', 'stroke-dashoffset')
                .attr('from', '100')
                .attr('to', '0')
                .attr('dur', '5s')
                .attr('repeatDur', this.globalConfig.animateRunTime);
        }else{
            line.append('animate')
                .attr('attributeName', 'stroke-dashoffset')
                .attr('from', '100')
                .attr('to', '0')
                .attr('dur', '5s')
                .attr('repeatCount', 'indefinite');
        }
    }

    resize() {
        this.svg.remove();
        this.width = this.getWidth();
        this.height = this.getHeight();
        this.anchorStore = {
            left: [], //左边的锚点
            right: [], //右边的锚点
            top: [], //顶部的锚点
            bottom: [], //底部的锚点
            originTop: [], //最左边的球右边偏上的锚点,特殊处理
            originBottom: [] //最左边的球右边偏下的锚点,特殊处理
        };
        this.draw();
    }
}

export default WaterWave;
